import React from 'react';
import { ICharacterPlayedWithFeed } from '@pvplevelup/core/dist/queries/character/character';
import { ProfilePlayedWith } from 'components/Profile/ProfilePlayedWith';

interface Props {
  playedWithFeed: ICharacterPlayedWithFeed | undefined;
  fetchMoreRecords: ()=>void;
  byCharacter: boolean;
  onChangeByCharacter: (byCharacter:boolean)=>void;
}

/** The character page's Played With tab. */
const CharacterPlayedWith: React.FC<Props> = ({playedWithFeed,fetchMoreRecords,byCharacter,onChangeByCharacter}) => {
  return (
    <ProfilePlayedWith playedWithFeed={playedWithFeed} fetchMoreRecords={fetchMoreRecords} byCharacter={byCharacter}
      onChangeByCharacter={onChangeByCharacter} />
  );
};

export {CharacterPlayedWith};
